import { render, staticRenderFns } from "./ProductSeries.vue?vue&type=template&id=67a5ac8e&scoped=true&"
import script from "./ProductSeries.vue?vue&type=script&lang=js&"
export * from "./ProductSeries.vue?vue&type=script&lang=js&"
import style0 from "./ProductSeries.vue?vue&type=style&index=0&id=67a5ac8e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67a5ac8e",
  null
  
)

export default component.exports